import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { Modal, notification } from 'ant-design-vue'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
import { toast } from '@/utils/util'
import Cookies from 'js-cookie'

// 创建 axios 实例
const service = axios.create({
  baseURL: window._CONFIG.domianURL,
  timeout: 0 // 请求超时时间
})

/**
 * 下载文件流用Blob解析
 * @param data
 */
function blobToJson(data) {
  let fileReader = new FileReader()
  let token = Vue.ls.get(ACCESS_TOKEN)
  fileReader.onload = function() {
    try {
      let jsonData = JSON.parse(this.result)  // 说明是普通对象数据，后台转换失败
      console.log('jsonData', jsonData)
      if (jsonData.status === 500) {
        console.log('token----------》', token)
        if (token && jsonData.message.includes('Token失效')) {
          Modal.error({
            title: vm.$t('systemBase.loginExpired'),
            content: vm.$t('systemBase.loginOut'),
            okText: vm.$t('systemBase.reRegister'),
            mask: false,
            onOk: () => {
              Vue.ls.remove(ACCESS_TOKEN)
              window.location.reload()
              // store.dispatch('Logout').then(() => {
              //   Vue.ls.remove(ACCESS_TOKEN)
              //   window.location.reload()
              // })
            }
          })
        }
      }
    } catch (err) {
      // 解析成对象失败，说明是正常的文件流
      console.log('blob解析fileReader返回err', err)
    }
  }
  fileReader.readAsText(data)
}

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

// axios请求拦截
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  //如果cookie里没有token就放进去
  Cookies.set(ACCESS_TOKEN,token)
  //update-begin-author:taoyan date:2020707 for:多租户
  let tenantid = Vue.ls.get(TENANT_ID)
  if (!tenantid) {
    tenantid = 0
  }
  config.headers[ 'tenant-id' ] = tenantid
  //update-end-author:taoyan date:2020707 for:多租户
  if (config.method == 'get') {
    if (config.url.indexOf('sys/dict/getDictItems') < 0) {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

// axios响应拦截
service.interceptors.response.use(response => {
  const vm = window.vm
  let data = response.data
  if (data.code === 502) {
    return toast(vm.$t('systemBase.loginOut'))
  }
  // todo 等后端发版统一后要去掉==0
  if (data.code !== 200 && data.code !== 0) {
    let type = response.request.responseType
    // 文件流类型没有code特殊处理
    if(type !== 'blob') {
      toast(data.message || vm.$t('systemBase.requestFailed'))
      return Promise.reject(data)
    }
  }
  return data
}, error => {
  const vm = window.vm
  // http错误处理
  const errConfig = {
    403: vm.$t('systemBase.accessDenied'),
    500: res => {
      const token = Vue.ls.get(ACCESS_TOKEN)
      let type = res.data.request.responseType
      if (type === 'blob') {
        blobToJson(res.data)
      }
      if (token && res.data.message.includes('Token失效')) {
        Modal.error({
          title: vm.$t('systemBase.loginExpired'),
          content: vm.$t('systemBase.loginOut'),
          okText: vm.$t('systemBase.reRegister'),
          mask: false,
          onOk: () => {
            store.dispatch('Logout').then(() => {
              Vue.ls.remove(ACCESS_TOKEN)
              try {
                // let path = window.document.location.pathname
                let path = window.document.location.hash.split('#')[ 1 ]
                console.log('location pathname -> ' + path)
                if (path != '/' && path.indexOf('/user/login') == -1) {
                  window.location.reload()
                }
              } catch (e) {
                window.location.reload()
              }
            })
          }
        })
      }
    },
    404: vm.$t('systemBase.notFound'),
    504: vm.$t('systemBase.networkTimeout'),
    401: vm.$t('systemBase.unauthorized')
  }
  let data = error.response
  if (data) {
    let msg = errConfig[ data.status ]
    if (typeof msg === 'string') return toast(msg)
    errConfig[ data.status ](data)
  } else {
    toast(data || vm.$t('systemBase.systemServiceError'))
  }
  return Promise.reject(error)
})

export {
  installer as VueAxios,
  service as axios
}